import { useState, useEffect, useCallback, useContext } from "react";
import { useHttpClient } from "./http-hook";
import { AuthContext } from "../context/auth-context";

const useTickets = () => {
    const [tickets, setTickets] = useState([]);
    const { isLoading, error, sendRequest, clearError } = useHttpClient();
    const auth = useContext(AuthContext);

    const fetchTickets = useCallback(async () => {
        try {
            const response = await sendRequest("/api/tickets", "GET", null, {
                Authorization: "Bearer " + auth.token,
            });
            const ticketsArray = response?.data || [];
            setTickets(ticketsArray);
        } catch (err) {
            console.error("Error fetching tickets:", err);
            setTickets([]); // Set empty array on error
        }
    }, [sendRequest, auth.token]);

    useEffect(() => {
        fetchTickets();
    }, [fetchTickets]);

    const createTicket = useCallback(
        async (title, description, priority, status, assignedTo, orgId) => {
            try {
                const response = await sendRequest(
                    "/api/tickets",
                    "POST",
                    JSON.stringify({
                        title: title.trim(),
                        description: description.trim(),
                        priority: priority,
                        status: status,
                        assignedTo: assignedTo,
                        orgId: orgId,
                        createdAt: new Date(),
                    }),
                    {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + auth.token,
                    }
                );
                await fetchTickets();
                return response.data;
            } catch (err) {
                console.error("Error creating ticket:", err);
                throw err;
            }
        },
        [sendRequest, auth.token, fetchTickets]
    );

    const updateTicket = useCallback(
        async (id, title, description, priority, status, assignedTo) => {
            try {
                console.log("Updating ticket with id:", id);
                const response = await sendRequest(
                    `/api/tickets/${id}`,
                    "PATCH",
                    JSON.stringify({
                        title: title.trim(),
                        description: description.trim(),
                        priority: priority,
                        status: status,
                        assignedTo: assignedTo,
                    }),
                    {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + auth.token,
                    }
                );
                console.log("Update ticket response:", response);
                await fetchTickets();
                return true;
            } catch (err) {
                console.error("Error updating ticket:", err);
                throw err;
            }
        },
        [sendRequest, auth.token, fetchTickets]
    );

    const deleteTicket = useCallback(
        async (ticketId) => {
            try {
                await sendRequest(`/api/tickets/${ticketId}`, "DELETE", null, {
                    Authorization: "Bearer " + auth.token,
                });
                await fetchTickets(); // Refresh the tickets list
                return true;
            } catch (err) {
                console.error("Error deleting ticket:", err);
                throw err;
            }
        },
        [sendRequest, auth.token, fetchTickets]
    );

    return {
        tickets,
        isLoading,
        error,
        clearError,
        createTicket,
        updateTicket,
        deleteTicket,
    };
}

export default useTickets;